// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2E5Sv","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__27UTh"};